import React from 'react';
import Modal from 'react-modal';

import { stringToJsx } from '../../../shared/utility';
import styles from './PendingSignupModal.module.scss';

Modal.setAppElement('#root');

const customStyles = {
  content: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '460px',
    padding: 0,
    border: 'none',
    borderRadius: '16px',
    overflow: 'hidden',
    background: '#fff',
  },
  overlay: {
    backgroundColor: 'rgba(15, 23, 42, 0.55)',
    zIndex: 5,
  },
};

const EnvelopeIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="34"
    height="34"
    fill="none"
    stroke="#0046a4"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="5" width="18" height="14" rx="2.5" />
    <path d="M4 7l8 6 8-6" />
  </svg>
);

/**
 * Friendly "your account is almost ready" popup shown on the sign-in screen
 * while a just-signed-up (or reactivating) customer's account is still being
 * provisioned. Deliberately NOT styled like the red login-error block.
 *
 * `title` and `body` come from the login response's `pending_signup` field;
 * `body` is an HTML string (may contain <br/>), rendered via stringToJsx.
 */
export default function PendingSignupModal({ isOpen, title, body, onClose }) {
  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick
    >
      <div className={styles.Wrap}>
        <button
          className={styles.Close}
          type="button"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>

        <div className={styles.Header}>
          <span className={`${styles.Spark} ${styles.Spark1}`}>&#10022;</span>
          <span className={`${styles.Spark} ${styles.Spark2}`}>&#10022;</span>
          <span className={`${styles.Spark} ${styles.Spark3}`}>&#10022;</span>
          <div className={styles.Orb}>
            <EnvelopeIcon />
          </div>
        </div>

        <div className={styles.Content}>
          <h2 className={styles.Title}>{title}</h2>
          <div className={styles.Body}>{stringToJsx(body)}</div>
          <button className={styles.Button} type="button" onClick={onClose}>
            Sounds good
          </button>
        </div>
      </div>
    </Modal>
  );
}
